import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { first } from 'rxjs/operators';
import { NgxSpinnerService } from 'ngx-spinner';

import { AlertService, LunchpageService } from '../_services';
import { Globals } from '../_helpers';

@Component({
    selector: 'assessor-start-test',
    templateUrl: './launch-page.component.html',
})

export class LaunchpageComponent implements OnInit {

    userData = {};
    settings = {};
    instructions = [];
    loading = false;
    isCalled = true;
    returnUrl: string;
    student_id: string;
    isPC: number = 0;
    isPractical: number = 0;
    activeExam = {};
    practical_viva: number = 0;
    examid:number = 0;
    pageUrl:number = 1;
    vivatype: string = '';
    displayText: string = '';


    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private lunchpageService: LunchpageService,
        private alertService: AlertService,
        private globals: Globals,
        private spinner: NgxSpinnerService

    ) { }

    ngOnInit() {
        var step = this.route.snapshot.paramMap.get("step");
        var step2 = this.route.snapshot.paramMap.get("step2");
        this.userData = JSON.parse(localStorage.getItem('currentUser'));
        this.settings = this.userData['settings'];
        this.loading = true;
        this.activeExam = JSON.parse(localStorage.getItem('activeExam_PS'));
        this.examid = this.activeExam['exam_id'];

        if (step != '') 
        {
            this.student_id = step;
        }
        else 
        {
            this.router.navigateByUrl('/exam-list');
        }
        if(step2 != '' && atob(step2) == '&v2')
        {
            this.pageUrl = 2;
            this.displayText = 'Practical'; 
        }
        else if(atob(step2) == '&v1')
        {
            this.pageUrl = 1;             
            this.displayText = 'Viva';
        } 
        else if(atob(step2) == '&pc'){
            this.pageUrl = 3; 
        } 
        if (step2 == '') 
        {
            this.router.navigateByUrl('/student-list/'+ this.pageUrl);
        }
        else
        {
            this.vivatype = step2;
        }              
        /* Get Instructions of exam according to type */
        if (this.isCalled) {
            this.isCalled = false;
            this.getInstruction();
        }

        // get return url from route parameters or default to '/'
        this.returnUrl = '/';
    }


    private getInstruction() {
        this.spinner.show();
        this.lunchpageService.getInstructions(this.globals.root_url, this.userData['usercode'], this.userData['id'], this.examid)
            .pipe(first())
            .subscribe(
                data => {
                    if (data.code == 1000) {
                        let inst = (data.instruction).split('\n');
                        for (var i = 0; i < inst.length; ++i) {
                            let html = inst[i];

                            if (html != '') {
                                this.instructions[i] = { index: i + 1, text: html };
                                // console.log(this.instructions)
                            }
                        }
                        if(this.pageUrl == 2 && data.viva_practical == 1)
                        {
                            this.isPC = 0;
                        }
                        else if(this.pageUrl == 1 && data.viva_pc == 1)
                        {
                            this.isPC = 0;
                        }     
                        else if(this.pageUrl == 3 && data.viva_pc == 1)
                        {
                            this.isPC = 1;
                        }                                            
                        //this.isPC = data.viva_pc; 
/*                        console.log(this.pageUrl)
                        console.log(this.isPC)*/
                        
                        this.isPractical = data.viva_practical;
                        this.spinner.hide();
                    }
                    else if (data.status == 'COM_TOKEN_ERROR') {
                        this.loading = false;
                        this.router.navigateByUrl('/login');
                    }
                    else {
                        this.spinner.hide();
                    }
                },
                error => {
                    this.spinner.hide();
                }
            );
    }
    /*public theoryPaper(){
    	this.router.navigateByUrl('/theory-test');
    }*/

    public vivaPaper(practical) {
        if(practical == 1)
        {
            this.router.navigateByUrl('/viva-test/' + this.student_id + '/'+ this.vivatype);
        }
        else
        {
            this.router.navigateByUrl('/viva-test/' + this.student_id + '/' + this.vivatype);
        }
    }
    public vivaPC() {
        //console.log('viva PC');
        this.router.navigateByUrl('/viva-pc/' + this.student_id);
    }    
}
